import React from "react";

import "styles/loading.scss";

const Loading = () => <span className="loading" />;

export default Loading;
